import Header from '@components/layout/Header';
import FooterContact from '@components/layout/FooterContact';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BusyImage from '../../assets/images/frontend/404.png';

export interface SystemBusyPageProps {
  onRetry: () => void;
  retrying?: boolean;
}

export default function SystemBusyPage({ onRetry, retrying }: SystemBusyPageProps) {
  const { t } = useTranslation();
  return <>
    <Header notShowIconSideMenu={true} noAppSwitcher={true} clickLogoNoRedirect={true} />
    <div className="content">
      <div className="content-align-middle">
        <div className="d-flex align-items-center">
          <div className="text-center">
            <img src={BusyImage} width="240" className="mb-4" alt="" />
            <h3 className="title-header">{t('Common.Label.SystemBusy')}</h3>
            <p>{t('Common.Label.SystemBusyDetail')}</p>
            <button
              id="btn-system-busy-retry"
              type="button"
              className="btn btn-primary"
              disabled={retrying}
              onClick={onRetry}
            >
              {t('Common.Button.TryAgain')}
            </button>
          </div>
        </div>
      </div>
      <FooterContact />
    </div>
  </>;
}
